<template>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 v-if="isPublic" class="card-title">Public Workout Plans</h4>
            <h4 v-else class="card-title">Personalized Workout Plans</h4>
          </template>
          <template v-slot:headerAction>
            <Popper :placement="popperplacement"
            @open:popper="popperOpened" @close:popper="popperClosed" :disableClickAway="true" offsetDistance="50" :show="showPopper">
            <button ref="openPopperBtn" v-if="isMyPatient" class="btn btn-icon" @click="showPopper = !showPopper">
              <i class="fa fa-plus  mr-0" aria-hidden="true" />
            </button>
                <template #content v-if="isMyPatient">
                <iq-card class="modal-content">
                     <template v-slot:headerTitle>
                        <h5 v-if="isPublic" class="card-title">Create a Workout Plan Available to All Patients</h5>
                        <h5 v-else class="card-title">Create a Personalized Workout Plan</h5>
                    </template>
                    <template v-slot:default>
                          <form @submit.prevent="createWorkout">
                          <div class="form-group">
                            <label for="name">Name:</label>
                            <input name="name" class="form-control mb-0" :class="{'is-invalid': planNameInvalid}"
                                type="text" placeholder="Plan name" v-model="planName"/>
                          </div>
                           <div class="form-group">
                             <label>Select Device:</label>
                            <select v-model="selectedDevice" class="form-control mb-0">
                                    <option selected value="Knee Brace">Knee Brace</option>
                                    <option value="Glove">Glove</option>
                                    <option value="Neat">Neat</option>
                                    <option value="Band">Band</option>
                            </select>
                            <div class="invalid-feedback">
                            </div>
                          </div>
                        <div class="row"><label class="form-group col-md-12" for="specialities">Add Exercise:</label></div>
                        <div>
                          <div class="row" v-for="count in inputExercisesCount" :key="count">
                            <div class="form-group col-md-5">
                            <span>Exericse</span>
                             <select class="form-control mb-0" v-if="selectedDevice === 'Knee Brace'" v-model="inputExercises[count-1].exercise" :class="{'no-select': selectInvalid}">
                                    <option v-for="kneeBraceExercise in kneeBraceExercises" :key="kneeBraceExercise.id" :value="kneeBraceExercise.id">{{ kneeBraceExercise.id }}</option>
                            </select>
                            <select class="form-control mb-0" v-if="selectedDevice === 'Glove'" v-model="inputExercises[count-1].exercise">
                                    <option v-for="exercise in gloveExercises" :key="exercise.id" :value="exercise.id">{{ exercise.id }}</option>
                            </select>
                             <select class="form-control mb-0" v-if="selectedDevice === 'Neat'" v-model="inputExercises[count-1].exercise">
                                    <option v-for="exercise in neatExercises" :key="exercise.id" :value="exercise.id">{{ exercise.id }}</option>
                            </select>
                            <select class="form-control mb-0" v-if="selectedDevice === 'Band'" v-model="inputExercises[count-1].exercise">
                                    <option v-for="exercise in bandExercises" :key="exercise.id" :value="exercise.id">{{ exercise.id }}</option>
                            </select>
                          </div>
                          <div class="form-group col-md-5">
                            <span>Repetitions</span>
                            <select class="form-control mb-0" v-model="inputExercises[count-1].reps">
                                    <option v-for="number in 10" :key="number" :value="number">{{ number }}</option>
                            </select>
                          </div>
                           <div class="form-group col-md-2" v-if="count > 1">
                            <button class="remove-button btn" @click="removeAnother">Remove</button>
                          </div>
                        </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12">
                            <button class="add-button btn" @click="addAnother">Add another</button>
                          </div>
                          </div>
                          <b-button type="submit" variant="primary" class="mr-2" :class="{ disabled: dbPending }">Submit</b-button>
                      </form>
                       <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger mt-3" v-if="dbError">
                        <div class="iq-alert-text">{{ dbError }}</div>
                      </div>
                    </template>
                </iq-card>
                </template>
            </Popper>
          </template>
          <template v-slot:default>
            <div class="iq-search-bar">
              <div class="searchbox">
                <input type="text" class="text search-input" placeholder="Filter by device or workout name" v-model="searchInput">
                <span class="search-link"><i class="ri-search-line"></i></span>
              </div>
            </div>
            <ul :id="draggableId" class="doctors-lists m-0 p-0">
              <div  v-if="filteredPlans.length">
                <li v-for="plan in filteredPlans" :key="plan.id"
                  :class="{ active : showPlanDetails.includes(plan.id)}" class="single-plan">
                  <div class="collapsible d-flex mb-3 align-items-center">
                    <div class="user-img img-fluid" @click="handleDeleteClicked(plan.id)"
                      v-if="showPlanDetails.includes(plan.id) && !isPublic && isMyPatient"><button type="button" aria-label="Close" class="close">×</button>
                    </div>
                    <div class="user-img img-fluid" v-else><i class="las la-tasks"></i></div>
                  <div class="media-support-info ml-3">
                    <h6 class="draggable" :draggable="true" :id="plan.id">{{ plan.name }}</h6>
                    <p class="mb-0 font-size-12">{{ plan.device }}</p>
                  </div>
                  <i class="las la-angle-down" @click="togglePlan(plan.id)"></i>
                  </div>
                  <div v-show="showPlanDetails.includes(plan.id)">
                  <ul class="dropdown-content" v-if="plan.exerciseArray === undefined">
                      <li class="plan-details" v-for="(reps, name) in plan.exercises" :key="name">
                          <h6 class="mb-1"><i class="las la-tag"></i>  {{ name }} x {{ reps }}</h6>
                      </li>
                  </ul>
                  <ul class="dropdown-content" v-else>
                      <li class="plan-details" v-for="index in plan.exerciseArray.length" :key="index">
                          <h6 class="mb-1"><i class="las la-tag"></i>  {{ plan.exerciseArray[index - 1] }} x {{ plan.reps[index - 1] }}</h6>
                      </li>
                  </ul>
                  </div>
                </li>
              </div>
              <div v-else>No results.</div>
            </ul>
            <div>
                  <b-modal id="modal-center" centered title="Delete Workout Plan" v-model="confirmDeleteWorkoutModal" okVariant='danger'
                    @ok="deleteWorkoutPlan" @cancel="planToDelete = null">
                    <p class="my-4">Are you sure you want to delete this plan?</p>
                    <div role="alert" aria-live="polite" aria-atomic="true" class="alert text-white bg-danger alert- ">
                      <div class="iq-alert-icon"><i class="ri-information-line"></i></div>
                      <div class="iq-alert-text">This will permanently delete this plan, including any scheduled sessions for the current patient.</div>
                    </div>
                  </b-modal>
            </div>
          </template>
        </iq-card>
</template>

<script>
import IqCard from './xray/cards/iq-card.vue'
import useWindowResize from '../../useWindowResize'
import getCollection from '../services/getCollection'
import useCollection from '../services/useCollection'
import { deleteDocument } from '../services/useDocument'
import { doc, getDoc, updateDoc, deleteField } from 'firebase/firestore'
import firebase from '../../firebase'
import Popper from 'vue3-popper'
import { computed, ref, watch } from 'vue'

export default {
  components: { IqCard, Popper },
  props: ['workoutPlans', 'isMyPatient', 'isPublic', 'draggableId', 'patientUid'],
  emits: ['workoutPlanDeleted', 'workoutPlanCreated', 'calendarRefreshNeeded'],
  setup (props, context) {
    const { documents: exercises } = getCollection('exercises')
    const kneeBraceExercises = ref([])
    const gloveExercises = ref([])
    const bandExercises = ref([])
    const neatExercises = ref([])

    const selectedDevice = ref('Knee Brace')
    const inputExercisesCount = ref(1)
    const inputExercises = ref([{ exercise: '', reps: 1 }])
    const planName = ref(null)

    const planNameInvalid = ref(false)
    const selectInvalid = ref(false)

    const showPlanDetails = ref([])

    const popperplacement = ref('right')
    const { width } = useWindowResize()
    const openPopperBtn = ref(null)

    watch(width, () => {
      if (width.value < 800) {
        popperplacement.value = 'bottom'
      } else {
        popperplacement.value = 'right'
      }
    })

    watch(exercises, () => {
      kneeBraceExercises.value = []
      gloveExercises.value = []
      bandExercises.value = []
      neatExercises.value = []

      exercises.value.forEach(exercise => {
        switch (exercise.device) {
          case 'Neat':
            neatExercises.value.push(exercise)
            break
          case 'Knee Brace':
            kneeBraceExercises.value.push(exercise)
            break
          case 'Glove':
            gloveExercises.value.push(exercise)
            break
          default:
            bandExercises.value.push(exercise)
        }
      })
    })

    const addAnother = () => {
      inputExercises.value.push({ exercise: '', reps: 1 })
      inputExercisesCount.value++
    }

    const removeAnother = () => {
      inputExercises.value.pop()
      inputExercisesCount.value--
    }

    const togglePlan = (planId) => {
      if (showPlanDetails.value.includes(planId)) {
        showPlanDetails.value = showPlanDetails.value.filter(item => item !== planId)
      } else {
        showPlanDetails.value.push(planId)
      }
    }

    watch(selectedDevice, () => {
      inputExercises.value = [{ exercise: '', reps: 1 }]
      inputExercisesCount.value = 1
    })

    const popperClosed = () => {
      selectedDevice.value = 'Knee Brace'
      inputExercisesCount.value = 1
      inputExercises.value = [{ exercise: '', reps: 1 }]
      planName.value = null
      planNameInvalid.value = false
      selectInvalid.value = false
      openPopperBtn.value.innerHTML = '<i class="fa fa-plus  mr-0" aria-hidden="true" />'
    }

    const popperOpened = () => {
      openPopperBtn.value.innerHTML = '<i class="fa fa-minus  mr-0" aria-hidden="true" />'
    }

    // Create workout plan
    const { dbError, addDocToDb, dbPending } = useCollection('exerciseplan')

    const createWorkout = async () => {
      if (!planName.value || !planName.value.length) {
        planNameInvalid.value = true
        return
      }
      planNameInvalid.value = false

      if (!inputExercises.value[0].exercise.length) {
        selectInvalid.value = true
        return
      }
      selectInvalid.value = false

      const planToAdd = {
        name: planName.value,
        device: selectedDevice.value,
        exerciseArray: [],
        reps: []
      }

      inputExercises.value.forEach(input => {
        if (input.exercise.length) {
          planToAdd.exerciseArray.push(input.exercise)
          planToAdd.reps.push(input.reps)
        }
      })

      if (props.isPublic) {
        await addDocToDb(planToAdd)
      } else {
        planToAdd.userID = props.patientUid
        await addDocToDb(planToAdd)
      }

      if (!dbError.value) {
        context.emit('workoutPlanCreated')
        showPopper.value = false
        planName.value = null
        selectedDevice.value = 'Knee Brace'
        inputExercises.value = [{ exercise: '', reps: 1 }]
        inputExercisesCount.value = 1
      }
    }

    //  Delete Workout plan
    const { handleDelete } = deleteDocument('exerciseplan')
    const { handleDelete: handleDeleteScheduled } = deleteDocument('scheduledWorkoutsByExercise')

    const confirmDeleteWorkoutModal = ref(false)
    const planToDelete = ref(null)

    const handleDeleteClicked = (planId) => {
      confirmDeleteWorkoutModal.value = true
      planToDelete.value = planId
    }

    const deleteWorkoutPlan = async () => {
      await handleDelete(planToDelete.value)
      context.emit('workoutPlanDeleted')

      const docRef = doc(firebase.db, 'scheduledWorkoutsByExercise', planToDelete.value)
      const docSnap = await getDoc(docRef)
      if (docSnap.exists()) {
        for (const [patientUid, events] of Object.entries(docSnap.data())) {
          const scheduledWorkoutsRef = doc(firebase.db, 'scheduledWorkouts', patientUid)
          for (const [date, workouts] of Object.entries(events)) {
            const uuids = Object.keys(workouts)
            await Promise.all(uuids.map(async uuid => {
              await updateDoc(scheduledWorkoutsRef, { [`${date}.${uuid}`]: deleteField() })
            }))
          }
        }
        context.emit('calendarRefreshNeeded')
        await handleDeleteScheduled(planToDelete.value)
      }

      planToDelete.value = null
    }

    const showPopper = ref(false)

    // Filter
    const searchInput = ref(null)
    const filteredPlans = computed(() => {
      if (!searchInput.value || searchInput.value === '') {
        return props.workoutPlans
      } else {
        return props.workoutPlans.filter(plan => plan.name.toLowerCase().includes(searchInput.value.toLowerCase()) ||
          plan.device.toLowerCase().includes(searchInput.value.toLowerCase()))
      }
    })

    return {
      togglePlan,
      showPlanDetails,
      kneeBraceExercises,
      gloveExercises,
      bandExercises,
      neatExercises,
      selectedDevice,
      inputExercisesCount,
      addAnother,
      removeAnother,
      inputExercises,
      createWorkout,
      planName,
      planNameInvalid,
      selectInvalid,
      popperClosed,
      popperplacement,
      popperOpened,
      openPopperBtn,
      dbError,
      dbPending,
      deleteWorkoutPlan,
      confirmDeleteWorkoutModal,
      showPopper,
      handleDeleteClicked,
      searchInput,
      filteredPlans
    }
  }

}
</script>

<style scoped>
  .la-angle-down {
    margin-right: 10px;
    cursor: pointer;
  }

  .draggable {
    cursor: move;
    display: inline-block;
  }

.dropdown-content {
    padding: 0;
    margin-left: 30px;
}

.collapsible {
    width: 100%;
}

.active {
    background-color: var(--light-grey);
    border-radius: 15px;
    margin-bottom: 5px;
}

.single-plan {
    padding: 5px;
}

.btn.btn-icon {
    color: #b583bc;
}

.modal-content {
    width: 700px;
    height: max-content;
    max-height: 600px;
    overflow-y: auto;
    border: 2px solid var(--border-color);
    border-radius: 2%;
    padding-top: 20px;
    padding-bottom: 20px;
}

.remove-button {
    margin-top: 25px;
    height: 45px;
}

.add-button, .btn {
    margin-bottom: 10px;
    background-color: var(--light-grey) !important;
    color: var(--text-color) !important;
}

.no-select {
    border: 1px solid red !important;
}

.iq-search-bar {
  padding: 0px;
  margin-bottom: 20px;
}

.iq-search-bar .searchbox {
  width: 100%;
}

.form-group {
  padding-left: 0px;
  padding-right: 30px;
}

@media (max-width:800px) {
    .modal-content {
        width: 90vw;
    }

    .remove-button {
    margin-top: 0;
}
}

button.close {
  color: var(--muted-text-color);
}

</style>
